import { useEffect, useState } from 'react';
import { useGetCachedPaginatedData } from '../../cachedDataHooks';
import { ApiUrls } from '../apiUrls';
import { useRestOperations } from '../../../src/common/rest/restOperations';
import { useTranslation } from '../../../src/common/i18n/useTranslation';
import { useClientCompanyRegistrationContext } from '../../../src/components/client/companyRegistration/context/ClientCompanyRegistrationContext';
import { EngineOilTestDto, PageEngineOilTestDto } from '../../../src/api';
import { isDevOrLocalEnv } from '../../../src/configuration/confUtils';
import { getMaxEngineOilTestPagination } from '../../../src/utils/pagination';

function useUserEngineOilTestApi() {
    const translate = useTranslation();
    const { doDownloadFile } = useRestOperations();
    const [engineOilTests, setEngineOilTests] = useState<EngineOilTestDto[] | null>(null);
    const { userInfo, isAdmin } = useClientCompanyRegistrationContext();

    const enableFetch = () => {
        return !!userInfo && isAdmin !== undefined && (!isAdmin || isDevOrLocalEnv());
    };

    const { data: engineOilTestsData, isFetching: isEngineOilTestsFetching } =
        useGetCachedPaginatedData<PageEngineOilTestDto>({
            url: ApiUrls.userApi.getEngineOilTestsForCurrentUserManufacturer(),
            queryKey: 'ENGINE-OIL-TEST',
            enabled: enableFetch(),
            pagination: getMaxEngineOilTestPagination(),
        });

    useEffect(() => {
        if (engineOilTestsData) {
            setEngineOilTests((engineOilTestsData as PageEngineOilTestDto).content ?? []);
        }
    }, [engineOilTestsData]);

    const handleDownloadEngineOilTestFile = async (engineOilTestId: string, fileId: string, fileName?: string) => {
        await doDownloadFile(
            ApiUrls.userApi.downloadEngineOilTestFileById(engineOilTestId, fileId),
            fileName ?? translate('invoices_name')
        );
    };

    return {
        engineOilTests,
        isEngineOilTestsFetching,
        handleDownloadEngineOilTestFile,
    };
}

export default useUserEngineOilTestApi;
